import { useEffect, useState } from "react";
import { HStack, Checkbox, CloseButton, Box } from "@chakra-ui/react";
import { DragHandleIcon } from "@chakra-ui/icons";

function Task({ id, name, done, updateParent, deleteTask }) {
  const [isDone, setIsDone] = useState(null);

  useEffect(() => {
    setIsDone(done);
  }, [done]);

  const handleInputChange = (e) => {
    if (updateParent) {
      setIsDone(e.target.checked);
      updateParent(id, e.target.checked, name);
    }
  };

  const handleDelete = (e) => {
    if (deleteTask) {
      deleteTask(id);
    }
  };

  return (
    <Box pl={4} pr={2} w="full">
      <HStack w="full" key={id} justifyContent="space-between">
        <Checkbox
          onChange={handleInputChange}
          isChecked={isDone ? isDone : done}
        >
          {name}
        </Checkbox>
        {deleteTask ? (
          <HStack>
            <DragHandleIcon />
            <CloseButton onClick={handleDelete}></CloseButton>
          </HStack>
        ) : null}
      </HStack>
    </Box>
  );
}

export default Task;
